import { render, staticRenderFns } from "./OtherSettings.vue?vue&type=template&id=46ec7974&"
import script from "./OtherSettings.vue?vue&type=script&lang=js&"
export * from "./OtherSettings.vue?vue&type=script&lang=js&"
import style0 from "./OtherSettings.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VDivider,VMain,VSwitch})
